import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Card, { CardProps } from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import Divider from '@mui/material/Divider';

import { API } from 'const';
import { PassengerDocument_document$key } from '__generated__/PassengerDocument_document.graphql';

type Props = CardProps & {
  document: PassengerDocument_document$key;
};

const PassengerDocument = ({ document, sx = [], ...props }: Props) => {
  const { uuid, name, file } = useFragment(
    graphql`
      fragment PassengerDocument_document on PassengerDocument {
        uuid
        name

        file {
          fileName
        }
      }
    `,
    document
  );

  return (
    <Card
      variant="outlined"
      sx={[
        { display: 'flex', flexDirection: 'column' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}>
      <CardHeader
        title={name}
        subheader={file?.fileName}
        avatar={
          file ? <CheckIcon color="success" /> : <CloseIcon color="error" />
        }
        sx={{ flexGrow: 1 }}
      />

      <Divider />

      <CardActions disableSpacing={true}>
        <Button
          startIcon={<FileDownloadIcon />}
          size="small"
          href={`${API}/passenger-documents/${uuid}/file`}
          disabled={!file}>
          Atsisiųsti
        </Button>
      </CardActions>
    </Card>
  );
};

export default PassengerDocument;
